import template from './template.html'
import Controller from './metabody.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    storyObj: '=',
    authorObj: '=',
    companySettings: '=',
    picklists: '=',
    websitesObj: '=',
    errorCapture: '&',
    updateModel: '&',
    meta: '=',
  },
  controller: Controller,
  controllerAs: 'vm',
}
